import type { SyncLatestResponse, SyncResponse } from '@mathflat/domain/@entities/Guest/guest.dto'
import type { Guest } from '@mathflat/domain/@entities/Guest/type'

import maxios from '@/utils/axios/maxios'

export const guestApi = {
  // 응답은 이름 오름차순 정렬·페이지네이션 없는 전건
  getGuests: () => {
    return maxios.get<Guest[]>('/creverse/guests')
  },
  sync: () => {
    return maxios.post<SyncResponse>('/creverse/guests/sync')
  },
  getLatestSync: () => {
    return maxios.get<SyncLatestResponse>('/creverse/guests/sync/latest')
  },
}
